export const formatContactName = (
    firstName: string,
    insertion: string,
    lastName: string,
): string => {
    const parts = [firstName, insertion, lastName].filter(Boolean);
    return parts.join(" ");
};
